import React from 'react';

const renderStatusIcon = (flgSubmittable) => {
    return flgSubmittable ? 
        <i className="fa fa-check-circle-o pe-1 text-success" />
        : <i className="fa fa-exclamation-circle fa-inverse pe-1 text-danger"/>
};
export default renderStatusIcon;